<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'file-certificate']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption">{{ printName }}</v-list-tile-sub-title>
      <v-list-tile-title>{{ printScore }}</v-list-tile-title>
      <v-list-tile-sub-title class="caption" v-if="!isDateEmpty">
        <span class="font-weight-bold">取得時期：</span>{{ printDate }}
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu offset-y>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading || isLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-combobox
          v-model="form.name"
          label="資格名"
          :rules="rules.name"
          :items="getCertItems"></v-combobox>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field
          v-model="form.score"
          label="点数・級"
          :rules="rules.score"
          :suffix="printFormSuffix"></v-text-field>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-text-field
          v-model="printFormatedDate"
          maxlength="30"
          append-icon="event"
          @click:append="datepick"
          label="取得時期"></v-text-field>
        <v-dialog v-model="config.datepicker.date.status" max-width="290">
          <v-date-picker
            v-model="config.datepicker.date.data"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="datepicked"></v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutBackgroundsCert',
  components: {
    UtilConfirmModal
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'cert',
        status: {
          loading: false
        },
        datepicker: {
          date: {
            data: '',
            status: false
          }
        }
      },
      meta: {
        certs: [
          '英検',
          'TOEIC',
          'TOEFL',
          'TOEFL iBT',
          'IELTS'
        ],
        suffix: {
          '英検': '級',
          'TOEIC': '点',
          'TOEFL': '点',
          'TOEFL iBT': '点',
          'IELTS': '点'
        }
      },
      form: {
        name: '',
        score: '',
        date: '',
        note: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        score: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          name: dt.name ? dt.name : '',
          score: dt.score ? dt.score : '',
          date: dt.date ? dt.date : '',
          note: dt.note ? dt.note : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          name: this.$props.data.name ? this.$props.data.name : '',
          score: this.$props.data.score ? this.$props.data.score : '',
          date: this.$props.data.date ? this.$props.data.date : '',
          note: this.$props.data.note ? this.$props.data.note : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('cert_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '語学資格の削除',
        message: 'この語学資格を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.axios.post(this.$url.api + 'user/about/delete/meta', {
            id: this.$props.data.id
          }, {
            headers: {
              'user-token': this.$localStorage.get('jwt')
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'remove',
                data: {
                  type: 'certs',
                  id: res.data.data.id ? res.data.data.id : ''
                }
              })
            }
          })
        }
      })
    },
    datepick: function () {
      if (this.form.date.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.date, 'data', this.form.date)
      }
      this.$set(this.config.datepicker.date, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'date', this.config.datepicker.date.data)
      this.$set(this.config.datepicker.date, 'status', false)
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('cert_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('cert_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('cert_' + this.$props.data.id)
      )
    },
    printScore () {
      return (
        this.$props.data &&
        this.$props.data.score &&
        this.$props.data.name
      ) ? (this.$props.data.score + (this.meta.suffix[this.$props.data.name] ? this.meta.suffix[this.$props.data.name] : '')) : '語学資格'
    },
    printName () {
      return (
        this.$props.data &&
        this.$props.data.name
      ) ? this.$props.data.name : ''
    },
    isDateEmpty () {
      return !(
        this.$props.data && this.$props.data.date
      )
    },
    printDate () {
      if (this.$props.data && this.$props.data.date) {
        return (
          this.$props.data.date.split('-').filter(it => isFinite(it)).length === 3
        ) ? this.$moment(this.$props.data.date).format('YYYY/MM/DD') : this.$props.data.date
      } else {
        return ''
      }
    },
    printFormatedDate: {
      get: function () {
        if (this.form && this.form.date) {
          return (
            this.form.date.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$moment(this.form.date).format('YYYY/MM/DD') : this.form.date
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'date', newValue)
      }
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data && this.$props.data.note
      )
    },
    printFormSuffix () {
      return (
        this.form.name &&
        this.meta.suffix[this.form.name]
      ) ? this.meta.suffix[this.form.name] : ''
    },
    getCertItems () {
      return this.meta.certs
    }
  }
}
</script>
